import React from 'react'
import { Spinner } from '@telavita-core/react-design-kit'
import { useSelector } from 'react-redux'

import { useGetProfessionalAvailabilities } from 'hooks'
import { UserData } from 'models/Auth'

import { SelectAvailableProfessionalSchedule } from 'components'
import { UnavailabilityInfo } from './components'

import * as S from './styles'
import { useGetProfessionalProfile } from 'views/NpsSchedule/hooks/useGetProfessionalProfile'

interface NonRecurrentReservationBoxProps {
  patientUsername: string
  restrictions: Date[]
  handleNonRecurrentReservationDate: (date: string, index: number) => void
}

export const NonRecurrentReservationBox: React.FC<NonRecurrentReservationBoxProps> = ({
  patientUsername,
  restrictions,
  handleNonRecurrentReservationDate
}) => {
  const { username } = useSelector((state: UserData) => state.auth.userData)
  const {
    professionalProfile,
  } = useGetProfessionalProfile(username)

  const { data, isFetching, refetch } = useGetProfessionalAvailabilities({
    restrictions: restrictions.map((date) => date.toISOString()),
    patientUsername,
    professionalUsername: username,
    productCode: professionalProfile?.productCode,
  })

  return (
    <S.Container>
      <UnavailabilityInfo
        restrictions={restrictions}
        handleShowAvailabilityOptions={() => refetch()}
        alreadyHasData={data && data.length > 0}
      />

      {isFetching && (
        <S.SpinnerWrapper>
          <Spinner />
        </S.SpinnerWrapper>
      )}

      {data && data.map((availabilities, index) => {
        return (
          <SelectAvailableProfessionalSchedule
            key={index}
            professionalUsername={username}
            patientUsername={patientUsername}
            availabilityList={availabilities}
            handleDate={
              (singleDate) => handleNonRecurrentReservationDate(singleDate, index)
            }
          />
        )
      })}
    </S.Container>
  )
}
